/* eslint-disable @typescript-eslint/no-explicit-any */
import { CollectionQuery } from "../../../models/collection.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { DASHBOARD_ENDPOINT } from "../dashboard.endpoint"

const dashboardQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    countDashboardProperties: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.countProperties}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),

      providesTags: ["Count Dashboard Properties"],
    }),
    countDashboardUnits: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.countUnits}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Dashboard Units"],
    }),
    getTotalLeasePaymentsForPeriod: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.getTotalLeasePaymentsForPeriod}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),
      // providesTags: ["Count Dashboard Units"],
    }),
    getTotalPayments: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.getTotalPayments}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),
      // providesTags: ["Count Dashboard Units"],
    }),
    countDashboardTenants: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.countTenants}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Dashboard Tenants"],
    }),
    countDashboardOwners: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.countOwners}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Dashboard Owners"],
    }),
    countDashboardLeases: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.countLeases}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Dashboard Leases"],
    }),
    countDashboardRequests: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.countRequests}`,
        method: "get",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Dashboard Requests"],
    }),
    getMonthlyLeaseExpirations: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.getMonthlyLeaseExpirations}`,
        method: "GET",
        params: collectionQueryBuilder(data),
        // permission: "manage-notifications",
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // reportCollection = param
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countUnitDistribution: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${DASHBOARD_ENDPOINT.countUnitDistribution}`,
        method: "GET",
        params: collectionQueryBuilder(data),
        // permission: "manage-notifications",
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // reportCollection = param
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyCountDashboardOwnersQuery,
  useLazyCountDashboardPropertiesQuery,
  useLazyCountDashboardTenantsQuery,
  useLazyCountDashboardUnitsQuery,

  useLazyCountDashboardLeasesQuery,

  useLazyCountDashboardRequestsQuery,

  useLazyGetMonthlyLeaseExpirationsQuery,
  useLazyCountUnitDistributionQuery,
  useLazyGetTotalLeasePaymentsForPeriodQuery,
  useLazyGetTotalPaymentsQuery
} = dashboardQuery
